import { AppImage } from "@/shared/Components";
import type { Person } from "@/services/api";
import type { FC } from "react";
import { usePersonAvatar } from "../../lib";
import styles from "./styles.module.scss";

type Props = {
  person: Person;
  isEditable?: boolean;
};

export const PersonAvatar: FC<Props> = ({ person, isEditable = false }) => {
  const { handleUpload, handleDelete, src } = usePersonAvatar(person);

  return (
    <>
      <div className={styles["avatar"]}>
        <AppImage
          src={src}
          beforeRefreshUpload={(file) => handleUpload({ file })}
          onDeleteImageClick={handleDelete}
          isEditable={isEditable}
          className={styles.image}
        />
      </div>
    </>
  );
};
